import { User, AlertCircle } from 'lucide-react';

const ProfileModal = ({ show, onSubmit, formError }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-white/80 backdrop-blur-md">
      <div className="w-full max-w-sm bg-white border border-zinc-200 shadow-2xl p-8 rounded-xl text-center">
        <div className="w-12 h-12 bg-zinc-900 rounded-lg flex items-center justify-center mx-auto mb-6 text-white shadow-lg shadow-zinc-200">
          <User className="w-6 h-6" />
        </div>
        <h3 className="text-xl font-bold mb-2 text-zinc-900">
          Initialize Profile
        </h3>
        <p className="text-zinc-500 text-sm mb-8">
          Create your identity to participate.
        </p>

        <form onSubmit={onSubmit} className="space-y-5 text-left">
          {formError && (
            <div className="p-3 bg-red-50 border border-red-100 rounded flex items-start gap-2 text-red-600 text-sm">
              <AlertCircle className="w-4 h-4 shrink-0 mt-0.5" />
              {formError}
            </div>
          )}
          <div>
            <label className="block text-[10px] font-bold uppercase tracking-widest text-zinc-400 mb-2">
              Display Name
            </label>
            <input
              name="name"
              type="text"
              required
              className="w-full bg-zinc-50 border border-zinc-200 rounded px-3 py-2.5 text-sm font-medium focus:border-zinc-900 outline-none transition-colors"
              placeholder="e.g. Sarah Connor"
            />
          </div>
          <button className="w-full py-3 mt-2 bg-zinc-900 text-white rounded font-bold hover:bg-black transition-all shadow-lg hover:shadow-xl text-sm">
            Start Season
          </button>
        </form>
      </div>
    </div>
  );
};

export default ProfileModal;
